export default () => ({
  confirmIfSyndicating(event: Event) {
    const form = (event.target as HTMLElement).closest("form");
    if (!form) return;
    const checked = Array.from(
      form.querySelectorAll<HTMLInputElement>(
        'input[name*="syndication_sources"]:checked',
      ),
    );
    if (checked.length === 0) return;
    const targets = checked
      .map((el) => {
        const label = document.querySelector<HTMLElement>(
          `label[for="${el.id}"]`,
        );
        return label?.textContent?.trim() ?? el.value;
      })
      .join("\n  • ");
    if (!window.confirm(`This post will be syndicated to:\n  • ${targets}\n\nProceed?`)) {
      event.preventDefault();
    }
  },
});
